import { handleExpiredTokens } from 'api/apiReqSagaCreator/httpRequest';
import { ApiPaths } from 'api/constants';
import {
  ApiResponseAsync,
  translateAxiosErrorToApiError,
} from 'container/models';

import BaseRepo from '../../BaseRepo';
import {
  FreshdeskTokenResponse,
  IFreshdeskTokenRepo,
} from './IFreshdeskTokenRepo';

export class FreshdeskTokenRepo
  extends BaseRepo
  implements IFreshdeskTokenRepo
{
  getFreshdeskToken = (): ApiResponseAsync<FreshdeskTokenResponse> =>
    handleExpiredTokens(() =>
      this.client.post<FreshdeskTokenResponse>(
        ApiPaths.generateFreshdeskToken._(),
        {}
      )
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
}
